import g from "lodash/get";
import { theme } from "packages/dsaui/src/theme";

export const themeGet = <T = string>(path: string, fallBack: any = ""): T => {
  const css = g(theme, path, fallBack);
  return css;
};

export const resp = (
  mobile: string | number,
  desktop: string | number,
): (string | number | null)[] => [mobile, null, desktop];

export { cn } from "./cn";
